<div class="coupon-layout microsoft-coupon fixed-header">
  <app-header></app-header>
  <div class="main-content">
    <div class="microsoft-image">
      <div class="image">
          <div class="shadow"></div>
          <div class="on-top-shadow">
              <div class="adcore-logo white"><a href="https://www.adcore.com" target="_blank"><i></i></a></div>
              <span class="microsoft-tag-box"><a class="microsoft-tag partner" href="https://about.ads.microsoft.com/en-us/resources/partner/did/22581/us/adcore-inc" target="_blank"></a></span>
              <span class="microsoft-tag-box"><a class="microsoft-tag global-parthner" href="https://about.ads.microsoft.com/en-us/blog/post/june-2023/2023-microsoft-advertising-global-partner-award-winners#:~:text=Global%20Channel%20Partner,across%20the%20board" target="_blank"></a></span>
              <div class="content">
                  <div>Get Up to $1,000 Microsoft Ads</div>
                  <div>coupon in two easy steps.</div>
              </div>
              <div class="mic-eligible-btn"><button (click)="goToEligibleLink('microsoft')">For eligible accounts only</button></div>
              <div class="link-acc">
                  <app-link-steps [step1Text]="'Link your'" [step1SecText]="'Microsoft Ads account'" [step2Text]="'Redeem your'" [step2SecText]="'$1,000 coupon'" [stepMiddleText]="'Checking your eligibility...'" [showMiddleStep]="loading" [accountLinked]="loading"></app-link-steps>
                  <div class="buttons" *ngIf="!loading">
                      <div>
                          <div><p-button styleClass="link-btn" label="Link your Microsoft Ads account" (onClick)="openProviderDialog()"></p-button></div>
                          <span class="text">Or</span>
                          <span><a class="create-btn" (click)="openRecaptcha('create')">Create new account</a></span>
                      </div>
                  </div>
                  <div class="loader-box acc" *ngIf="loading">
                    <div class="acc-loader-green"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <app-metrics [merticData]="metricData"></app-metrics>
  <app-video-player videoPath="https://www.youtube.com/embed/U7crTQBgdsI" [type]="'microsoft'"></app-video-player>
  <app-powered [lang]="'en'" (linkBtnEvent)="openProviderDialog()" [isFirstStep]="true" [type]="'microsoft'"></app-powered>
  <app-questions [listItemsType]="'microsoft'" [title]="'Q&A'" [selectedAccordinAIndex]="openTabIndex" (changeSelectedTabIndex)="changeSelectedTabIndex($event)"></app-questions>
  <app-footer [lang]="'en'"></app-footer>
  </div>
</div>
<p-dialog [(visible)]="showDialog" styleClass="create-acc-dialog" [modal]="true" [blockScroll]="true">
  <ng-template pTemplate="header">
    {{dialogHeader}}
    <i class="success-icon" *ngIf="dialogHeader === 'Account created successfully'"></i>
  </ng-template>
  <p>{{dialogBody}}</p>
  <ng-template pTemplate="footer">
    <p-button *ngIf="redeemButton" label="Got it" [disabled]="loading" (onClick)="got_it('create')" styleClass="primary-btn"></p-button>
  </ng-template>
</p-dialog>
<p-toast key="msgTemplate" position="center" (onClose)="close($event)">
    <ng-template let-message pTemplate="message">
      <app-msg-template [message]="message" (confirm)="got_it('link')">
        <div><p>{{message.detail}}</p></div>
      </app-msg-template>
    </ng-template>
</p-toast>
